export function applyTabState(tabButtons, panels, activeIndex) {
  tabButtons.forEach((tab, index) => {
    const isActive = index === activeIndex;
    tab.dataset.active = isActive ? "true" : "false";
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
    tab.setAttribute("tabindex", isActive ? "0" : "-1");
  });

  panels.forEach((panel, index) => {
    panel.hidden = index !== activeIndex;
  });
}
